const i = ({
  colorTheme: n = "light",
  disabled: s = !1,
  errored: g = !1,
  theme: r
}) => g ? r == null ? void 0 : r.get(`tokens.text.${n}.error`) : s ? r == null ? void 0 : r.get(`tokens.text.${n}.disabled`) : r == null ? void 0 : r.get(`tokens.text.${n}.primary`);
export {
  i as getColor
};
